import React from 'react'
import { useNavigate } from 'react-router-dom'
import type { Group } from 'types/group'
import type { PlaylistId } from 'types/playlist'
import type { Track } from 'types/track'
import { DropdownMenu } from 'components/ds'

type Props = {
  track: Track
  addToCustomGroup: boolean
  closeMenu: () => void
  disabled: boolean
  group: Group | null | undefined
  sourcePlaylistId?: PlaylistId | null | undefined
}

const AddToChannel = ({
  addToCustomGroup,
  track,
  disabled,
  group,
  sourcePlaylistId,
}: Props): React.ReactNode => {
  const navigate = useNavigate()
  if (!track?.permissions?.manage || !addToCustomGroup) return null

  const params = new URLSearchParams()
  if (sourcePlaylistId) params.set('source_playlist', String(sourcePlaylistId))
  if (group?.id) params.set('source_group', String(group.id))
  const qs = params.toString()
  const to = `/explorer/tracks/${track.id}/add-to-channel${qs ? `?${qs}` : ''}`

  return (
    <DropdownMenu.Item disabled={disabled} onSelect={() => navigate(to)}>
      Channel
    </DropdownMenu.Item>
  )
}

export default AddToChannel
